export interface PaymentLogByCountry {
    changeDate?: string;
    dateObject?: Date;
    userId?: string;
    fullName?: string;
    countryCode?: string;
    countryDesc?: string;
    parameterId?: string;
    parameterDetail?: ParameterDtlData;
    parameterDetailPrev?: ParameterDtlData;
    parameterDetailNew?: ParameterDtlData;
    typeOfChange?: string;
    isYesNo?: boolean;
}

export interface ParameterDtlData {
    parameterGroup?: string;
    parameterGroupDescription?: string;
    parameters?: Array<ParameterData>;
    parameterGroupLongDescription?: string;
}

export interface ParameterData {
    countryCode?: string;
    companyCode?: string;
    parameterCode?: string;
    parameterId?: string;
    value1?: string;
}

export interface PaymentLogByCountryDTO {
    paymentLogsByCountry: Array<PaymentLogByCountry>;
}
